import Message from "./Message";
import Phone from "./Phone";

const icons = {
    message: <Message />,
    phone: <Phone />,
    smallMessage: <Message small={true}/>
}

export default icons;